// extracted by mini-css-extract-plugin
export default {"container":"style_container__pBL7N","readMoreContainer":"style_readMoreContainer__4vwG4"};